/**
 * API Service for ApprovalStatusRenderer
 */

import { makeCygnusApiCall } from "../../../../../api/api";


/**
 * Fetches engagement approval page page data.
 * @params ProcessedTemplateId
 * @returns data array.
 */
export const fetchApprovalPageData = async (ProcessedTemplateId: any): Promise<any[]> => {  
  
  const url = `/engagement-letter/el_approvals/?ProcessedTemplateId=${ProcessedTemplateId}&SendForApproval=Y`;

  const response = await makeCygnusApiCall({
    type: "GET",
    url,
    show_message: true,
    customized_success_message: "Fetched approval page data successfully.",
    customized_failure_message:
      "Unable to fetch approval page data, please try again.",
    customized_error_message:
      "Error occurred while fetching approval page data. Please contact support.",
    forMDM: true,
  });

  if (response.success) {    
    return response.data;
  } else {
    return [];
  }
};